<template>
  <v-container fluid>
    <PageHeaderSlot showBackButton />

    <v-form ref="dataForm" @submit.prevent="">
      <v-card>
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="categoryName"
                placeholder="categoryName"
                :fieldValue.sync="formData.name"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div class="d-flex align-center mt-4">
        <FormButton @click="save()" />
        <FormButton
          v-if="$validate.DataValid(id)"
          class="ml-4"
          outlined
          color="error"
          text="delete"
          @click="handleDelete()"
        />
      </div>
    </v-form>
  </v-container>
</template>

<script>
import FormInput from '@/components/formField/FormInput.vue'

export default {
  name: 'BlogCategoryDetails',
  inject: ['getConfirmDialogRef'],
  components: {
    FormInput,
  },
  computed: {
    id() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    dispatchUpdateOnChange() {
      return this.$validate.DataValid(this.id)
    },
  },
  data: () => ({
    formData: {
      name: '',
    },
  }),
  methods: {
    async _getBlogCategoryById() {
      try {
        const data = await this.$Fetcher.GetBlogCategoryById(this.id)
        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.$set(this.formData, key, data[key])
          }
        }
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.showAlert({
            message: 'noData',
            returnLink: 'BlogCategoryList',
          })
        }
      }
    },

    // -- (確認)
    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)

      try {
        const payload = {
          name: this.formData.name,
        }

        let message = {}
        if (this.$validate.DataValid(this.id)) {
          await this.$Fetcher.UpdateBlogCategory(this.id, payload)
          message = {
            message: 'message.saveSuccess',
            refresh: true,
          }
        } else {
          await this.$Fetcher.NewBlogCategory(payload)
          message = {
            message: 'message.createSuccess',
            redirect: 'BlogCategoryList',
          }
        }
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          ...message,
          type: 'success',
        })
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: this.$validate.DataValid(this.id) ? 'message.saveFail' : 'message.createFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    // -- (刪除)
    async handleDelete() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          await this.$Fetcher.DeleteBlogCategory(this.id)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
            redirect: 'BlogCategoryList',
          })
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: BlogCategoryDetails')
      if (this.$validate.DataValid(this.id)) {
        await this._getBlogCategoryById()
      }

      this.$store.dispatch('toggleLoadingPage', false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      next()
    }
  },
}
</script>
